import {
  Autocomplete,
  Badge,
  Button,
  CircularProgress,
  createTheme,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  ThemeProvider,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import {
  TheaterComedy,
  Cancel,
  CheckCircle,
  Warning,
  IntegrationInstructions,
  BugReport,
  Summarize,
} from "@mui/icons-material";
import apiClient from "@lift-admin/utils/apiClient";
import { Toastify } from 'lift-ui';
import { useProcessContext } from "../process-context";
import { statusColorMap } from "./color-map";
import moment from "moment";
import { Tooltip } from "@lift-admin/ui/tooltip";
import { actionLog } from "../../../App";

const theme = createTheme({
  palette: {
    primary: {
      main: "#16306D",
    },
  },
  typography: {
    fontFamily: '"Figtree", sans-serif',
  },
});
const options = ["main", "dev-1", "stg"];
const IntegrationTestTrigger = () => {
  const [allLogs, setAllLogs] = useState<any[]>([]);
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(25);
  const [repository, setRepository] = useState<string>("");
  const [branch, setBranch] = useState<any>(null);
  const [testParamsBranch, setTestParamsBranch] = useState<any>(null);
  const [queueStatus, setQueueStatus] = useState<any>(null);
  const [loading, setLoading] = useState({
    logs: false,
    queueStatus: false,
    cancelTest: false,
  });
  const [dialogOpen, setDialogOpen] = useState({
    trigger: false,
    queue: false,
    error: false,
    cancelTest: false,
  });
  const [currentError, setCurrentError] = useState<string>("");
  const [currentTest, setCurrentTest] = useState<any>(null);

  const handleChangePage = (_: any, newPage: any) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleGetAllLogs = async () => {
    setLoading((prev) => ({ ...prev, logs: true }));
    try {
      const res = await apiClient.get("/testingserver/tests");
      const sortedLogs = [...res.data].sort(
        (a, b) =>
          new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      );
      setAllLogs(sortedLogs);
    } catch (err: any) {
      console.log(err, "error");
    } finally {
      setLoading((prev) => ({ ...prev, logs: false }));
    }
  };
  useEffect(() => {
    handleGetAllLogs();
  }, []);
  console.log(allLogs, "allLogs");
  const handleClickOpen = () =>
    setDialogOpen((prev) => ({ ...prev, trigger: true }));
  const handleClose = () => {
    setDialogOpen((prev) => ({ ...prev, trigger: false }));
    setRepository("");
    setBranch(null);
    setTestParamsBranch(null);
  };
  const handleProceed = async () => {
    // your proceed logic here
    try {
      const body = {
        repo_name: repository,
        branch: branch,
        test_params: {
          branch: testParamsBranch,
        },
        priority: 1,
      };

      const res = await apiClient.post("/testingserver/tests", body);

      console.log(res, "res");
      console.log(body);

      Toastify(
        "success",
        `Triggered integration test :\n${repository} on branch ${branch} with test params ${testParamsBranch}`
      );
      handleGetAllLogs();
      handleClose();
      await actionLog?.actionLogTrack(
        JSON.stringify({
          message: "Integration Test Triggered",
          status: 200,
          method: "POST",
          url: "/testingserver/tests",
        }),
        false
      );
    } catch (err: any) {
      console.log(err, "error");
      Toastify("error", err?.response?.message || "Something went wrong");
      await actionLog?.actionLogTrack(
        JSON.stringify({
          message: `Integration Trigger failed: ${err?.response?.data?.message}`,
          status: err?.response?.status || 500,
          method: "POST",
          url: "/testingserver/tests",
        }),
        false
      );
    }
  };
  const handleStatusQueue = async () => {
    setLoading((prev) => ({ ...prev, queueStatus: true }));
    try {
      const res = await apiClient.get("/testingserver/queue/status");
      setQueueStatus(res.data);
    } catch (err: any) {
      console.log(err, "error");
    } finally {
      setLoading((prev) => ({ ...prev, queueStatus: false }));
    }
  };
  const handleOpenQueueDialog = async () => {
    setDialogOpen((prev) => ({ ...prev, queue: true }));
    await handleStatusQueue();
  };
  const handleCloseQueueDialog = () =>
    setDialogOpen((prev) => ({ ...prev, queue: false }));
  const handleOpenError = (message: string) => {
    setCurrentError(message);
    setDialogOpen((prev) => ({ ...prev, error: true }));
  };
  const handleCloseError = () => {
    setDialogOpen((prev) => ({ ...prev, error: false }));
    setCurrentError("");
  };

  const handleOpenCanceltestConfirmation = (row: any) => {
    setCurrentTest(row);
    setDialogOpen((prev) => ({ ...prev, cancelTest: true }));
  };
  const handleCloseCanceltestConfirmation = () => {
    setCurrentTest(null);
    setDialogOpen((prev) => ({ ...prev, cancelTest: false }));
  };

  const handleCancelTest = async () => {
    setLoading((prev) => ({ ...prev, cancelTest: true }));
    try {
      const res = await apiClient.delete(
        `/testingserver/tests/${currentTest?.test_id}`
      );
      console.log(res, "res");
      Toastify(
        "success",
        `Cancelled test with service name ${currentTest?.service_name}`
      );
      handleGetAllLogs();
      handleCloseCanceltestConfirmation();
    } catch (err: any) {
      console.log(err, "error");
      handleGetAllLogs();
      Toastify("error", err?.response?.data?.detail || "Something went wrong");
    } finally {
      setLoading((prev) => ({ ...prev, cancelTest: false }));
    }
  };
  return (
    <div style={{ backgroundColor: "rgb(249, 249, 249)" }}>
      <div style={{ backgroundColor: "rgb(249, 249, 249)", margin: "9px 0" }}>
        <div
          className="head"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div className="head-txt" style={{ marginBottom: 0 }}>
            Integration Test Trigger
          </div>
          <ThemeProvider theme={theme}>
            <div style={{ display: "flex", gap: "1rem" }}>
              <Button
                variant="outlined"
                size="large"
                onClick={handleGetAllLogs}
                disabled={loading?.logs}
                sx={{
                  // marginRight: "2rem",
                  textTransform: "none",
                }}
              >
                {loading?.logs ? (
                  <>
                    <CircularProgress
                      size={20}
                      sx={{ color: "#16306D", marginRight: "0.5rem" }}
                    />
                    Loading Logs
                  </>
                ) : (
                  "Refresh Logs"
                )}
              </Button>

              <Button
                variant="outlined"
                size="large"
                onClick={handleOpenQueueDialog}
                sx={{
                  // marginRight: "2rem",
                  textTransform: "none",
                }}
              >
                Show Queue
              </Button>
              <Button
                variant="contained"
                size="large"
                onClick={handleClickOpen}
                sx={{
                  marginRight: "2rem",
                  textTransform: "none",
                  marginBottom: "2px",
                }}
              >
                Start Trigger
              </Button>
            </div>
          </ThemeProvider>
        </div>
        <div className="secondary-div"></div>
        <Divider />
      </div>
      <div style={{ backgroundColor: "rgb(249, 249, 249)", height: "100vh" }}>
        <Paper
          className="controller-paper"
          style={{
            margin: "2rem",
            boxShadow: "0 0 10px 1px rgb(241, 241, 241)",
          }}
        >
          <TableContainer sx={{ maxHeight: "calc(100% - 60px)" }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{
                      fontFamily: '"Figtree", sans-serif',
                      color: "grey",
                    }}
                  >
                    Service Name
                  </TableCell>
                  <TableCell
                    style={{
                      fontFamily: '"Figtree", sans-serif',
                      color: "grey",
                    }}
                  >
                    Github Run id
                  </TableCell>
                  <TableCell
                    style={{
                      fontFamily: '"Figtree", sans-serif',
                      color: "grey",
                    }}
                  >
                    Github Workflow Id
                  </TableCell>
                  <TableCell
                    style={{
                      fontFamily: '"Figtree", sans-serif',
                      color: "grey",
                    }}
                  >
                    Test Id
                  </TableCell>
                  <TableCell
                    style={{
                      fontFamily: '"Figtree", sans-serif',
                      color: "grey",
                      // textAlign: "center",
                    }}
                  >
                    <span
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      {" "}
                      Status
                    </span>
                  </TableCell>
                  <TableCell
                    style={{
                      fontFamily: '"Figtree", sans-serif',
                      color: "grey",
                    }}
                  >
                    Created At
                  </TableCell>
                  <TableCell
                    style={{
                      fontFamily: '"Figtree", sans-serif',
                      color: "grey",
                    }}
                  >
                    Started At
                  </TableCell>

                  <TableCell
                    style={{
                      fontFamily: '"Figtree", sans-serif',
                      color: "grey",
                    }}
                  >
                    Completed At
                  </TableCell>
                  <TableCell
                    style={{
                      fontFamily: '"Figtree", sans-serif',
                      color: "grey",
                    }}
                  >
                    Controls
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {allLogs
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row: any, idx: any) => {
                    return (
                      <>
                        <TableRow hover role="checkbox" tabIndex={-1} key={idx}>
                          <TableCell
                            style={{
                              fontFamily: '"Figtree", sans-serif',
                              fontWeight: "500",
                            }}
                          >
                            <div>
                              <p>{row?.service_name}</p>
                            </div>
                          </TableCell>
                          <TableCell
                            style={{
                              fontFamily: '"Figtree", sans-serif',
                              fontWeight: "500",
                            }}
                          >
                            <div>
                              <p>{row?.github_run_id}</p>
                            </div>
                          </TableCell>
                          <TableCell
                            style={{
                              fontFamily: '"Figtree", sans-serif',
                              fontWeight: "500",
                            }}
                          >
                            <div>
                              <p>{row?.github_workflow_id}</p>
                            </div>
                          </TableCell>
                          <TableCell
                            style={{
                              fontFamily: '"Figtree", sans-serif',
                              fontWeight: "500",
                            }}
                          >
                            <div>
                              <p>{row?.test_id}</p>
                            </div>
                          </TableCell>
                          <TableCell
                            style={{
                              fontFamily: '"Figtree", sans-serif',
                              fontWeight: "500",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <p
                                style={{
                                  backgroundColor:
                                    statusColorMap[row?.status].background,
                                  color: statusColorMap[row?.status].color,
                                  border: "1px solid",
                                  borderColor:
                                    statusColorMap[row?.status].color,
                                  fontWeight: 500,
                                  borderRadius: "20px",
                                  textAlign: "center",
                                  fontSize: "0.8rem",
                                  textTransform: "capitalize",
                                  width: "75px",
                                  padding: "3px",
                                }}
                              >
                                {row?.status.replace("_", " ")}
                              </p>
                            </div>
                          </TableCell>
                          <TableCell
                            style={{
                              fontFamily: '"Figtree", sans-serif',
                              fontWeight: "500",
                            }}
                          >
                            <div>
                              <p>
                                {row?.created_at &&
                                  moment(new Date(row.created_at + "z")).format(
                                    "MM-DD-YYYY hh:mm A"
                                  )}
                              </p>
                            </div>
                          </TableCell>
                          <TableCell
                            style={{
                              fontFamily: '"Figtree", sans-serif',
                              fontWeight: "500",
                            }}
                          >
                            <div>
                              <p>
                                {row?.started_at &&
                                  moment(new Date(row.started_at + "z")).format(
                                    "MM-DD-YYYY hh:mm A"
                                  )}
                              </p>
                            </div>
                          </TableCell>
                          <TableCell
                            style={{
                              fontFamily: '"Figtree", sans-serif',
                              fontWeight: "500",
                            }}
                          >
                            <div>
                              <p>
                                {row?.completed_at &&
                                  moment(
                                    new Date(row.completed_at + "z")
                                  ).format("MM-DD-YYYY hh:mm A")}
                              </p>
                            </div>
                          </TableCell>
                          <TableCell
                            style={{
                              fontFamily: '"Figtree", sans-serif',
                              fontWeight: "500",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                padding: "0 10px",
                              }}
                            >
                              <Tooltip title={"See Error Message"}>
                                {row?.error_message && (
                                  <Summarize
                                    onClick={() =>
                                      handleOpenError(row.error_message!)
                                    }
                                    style={{
                                      color: "#16306D",
                                      cursor: "pointer",
                                      // marginRight: 'auto',
                                    }}
                                  />
                                )}
                              </Tooltip>
                              {/* {(row?.status !== "completed" &&
                                row?.status !== "failed") && (
                                <Cancel
                                  style={{
                                    color: "red",
                                    cursor: "pointer",
                                    marginLeft: "auto",
                                  }}
                                  onClick={() => {
                                    handleOpenCanceltestConfirmation(row);
                                  }}
                                />
                              )} */}
                            </div>
                          </TableCell>
                        </TableRow>
                      </>
                    );
                  })}
              </TableBody>
            </Table>
            {/* {listLoad ? (
            [1, 2, 3, 4].map((d, i) => {
              return (
                <Fragment key={i}>
                  <TableSkeleton />
                </Fragment>
              );
            })
          ) : (
            <></>
          )} */}
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[25, 50, 100, 200, 500]}
            component="div"
            count={allLogs.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            style={{}}
            sx={{
              marginTop: "10px",
              fontFamily: '"Figtree", sans-serif',
            }}
          />
        </Paper>
      </div>
      <ThemeProvider theme={theme}>
        <Dialog
          open={dialogOpen?.trigger}
          onClose={handleClose}
          // make it wider
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>Integration Trigger Test</DialogTitle>
          <DialogContent dividers>
            <TextField
              fullWidth
              label="Repository Name"
              value={repository}
              onChange={(e) => setRepository(e.target.value)}
              sx={{ mt: 1, mb: 2 }}
            />
            <Autocomplete
              fullWidth
              options={options}
              value={branch}
              onChange={(_, v) => setBranch(v)}
              renderInput={(params) => (
                <TextField {...params} label="Select Base Branch" />
              )}
              sx={{ mb: 2 }}
            />
            <Autocomplete
              fullWidth
              options={options}
              value={testParamsBranch}
              onChange={(_, v) => setTestParamsBranch(v)}
              renderInput={(params) => (
                <TextField {...params} label="Select Comparison Branch" />
              )}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleClose}
              variant="outlined"
              style={{ textTransform: "none" }}
            >
              Close
            </Button>
            <Button
              onClick={handleProceed}
              variant="contained"
              style={{ textTransform: "none" }}
            >
              Proceed
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={dialogOpen?.queue}
          onClose={handleCloseQueueDialog}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>Queue Status</DialogTitle>
          <DialogContent dividers>
            {loading?.queueStatus ? (
              <Typography>Loading…</Typography>
            ) : queueStatus ? (
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography variant="subtitle2">Queue Length</Typography>
                  <Typography>{queueStatus.queue_length}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2">Running Tests</Typography>
                  <Typography>{queueStatus.running_tests}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2">Max Concurrent</Typography>
                  <Typography>{queueStatus.max_concurrent_tests}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2">DB Locked</Typography>
                  <Typography>
                    {queueStatus.db_locked ? "Yes" : "No"}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2">Active Backup ID</Typography>
                  <Typography
                    sx={{
                      whiteSpace: "normal", // allow line breaks
                      overflowWrap: "break-word", // break long words
                      wordBreak: "break-word", // ensure wrapping
                    }}
                  >
                    {queueStatus.active_backup_id ?? "—"}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="subtitle2">Backup Users</Typography>
                  <Typography>{queueStatus.backup_users_count}</Typography>
                </Grid>
              </Grid>
            ) : (
              <Typography color="textSecondary">No status fetched</Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseQueueDialog}>Close</Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={dialogOpen?.error}
          onClose={handleCloseError}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>Error Details</DialogTitle>
          <DialogContent dividers>
            <DialogContentText
              sx={{
                whiteSpace: "pre-wrap",
                fontFamily: '"Figtree", sans-serif',
              }}
            >
              {currentError}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseError} variant="outlined">
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={dialogOpen.cancelTest}
          onClose={handleCloseCanceltestConfirmation}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>Cancel Test</DialogTitle>
          <DialogContent dividers>
            <DialogContentText
              sx={{
                whiteSpace: "pre-wrap",
                fontFamily: '"Figtree", sans-serif',
              }}
            >
              {currentTest ? (
                <>
                  You are about to cancel the integration test&nbsp;
                  <strong>{currentTest?.service_name}</strong> (ID:{" "}
                  <code>{currentTest.test_id}</code>).
                  <br />
                  <br />
                  This action <strong>cannot</strong> be undone. Are you sure
                  you want to proceed?
                </>
              ) : (
                "Loading…"
              )}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleCloseCanceltestConfirmation}
              variant="outlined"
              sx={{ textTransform: "none" }}
            >
              No, Keep Test
            </Button>
            <Button
              onClick={handleCancelTest}
              variant="contained"
              sx={{ textTransform: "none" }}
            >
              Yes, Cancel Test
            </Button>
          </DialogActions>
        </Dialog>
      </ThemeProvider>
    </div>
  );
};

export default IntegrationTestTrigger;
